import React from 'react';
import { X } from 'lucide-react';

interface ImpoundConfirmationPopupProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isCreating: boolean;
}

const ImpoundConfirmationPopup: React.FC<ImpoundConfirmationPopupProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isCreating
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
        onClick={onCancel}
      />
      
      {/* Popup */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-sm bg-background rounded-xl shadow-xl z-50 overflow-hidden">
        <div className="p-5">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Complete Call</h3>
            <button 
              onClick={onCancel}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors"
            >
              <X size={18} className="text-gray-500" />
            </button>
          </div>
          
          <p className="text-gray-700 mb-6">Is this vehicle impounded?</p>
          
          <div className="flex items-center justify-end gap-3 mt-6">
            <button
              onClick={onCancel}
              disabled={isCreating}
              className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50"
            >
              No
            </button>
            <button
              onClick={onConfirm}
              disabled={isCreating}
              className="px-4 py-2 text-primary-foreground bg-primary hover:bg-primary/90 rounded-lg transition-colors disabled:opacity-50 flex items-center"
            >
              {isCreating ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Creating...
                </>
              ) : (
                'Yes'
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImpoundConfirmationPopup; 